export function buildSceneCameraList(camerasByUuid = {}) {
  const rows = Object.values(camerasByUuid || {}).map((camera, idx) => {
    const uuid = String(camera?.uuid || "").trim() || `camera-${idx + 1}`;
    const name = String(camera?.name || "").trim() || `camera_${uuid}`;
    return {
      key: uuid,
      uuid,
      name,
      label: name,
    };
  });

  rows.sort((a, b) => a.label.localeCompare(b.label));
  return rows;
}
